import { Key, useEffect, useMemo, useState } from "react";
import {
  Divider,
  Spin,
  Select,
  Form,
  Input,
  Modal,
  DatePicker,
  Switch,
  Col,
  Row,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import TableFilter from "../common/TableFilter/TableFilter";
import Breadcrumb from "../common/Breadcrumb/Breadcrumb";
import {
  showErrorNotification,
  showSuccessNotification,
} from "../../util/notifications";
import Button from "../common/Button/Button";
import filterColumns from "./filterColumns";
import { fetchVendorList } from "src/components/vendor/vendor-sagas";
import { getCollectionByVendor } from "src/components/kits/kitMaintenance/sagas";
import { getOffices } from "src/components/systemPreference/sagas";
import styled from "styled-components";
import { getUserName } from "../common/UserDetails";
import GenericGrid from "../common/Grid/GenericGrid";
import { MRT_RowSelectionState } from "material-react-table";
import { fetchOfficeReplenishmentPOList, MODULE_KEY } from "./actions";
import { OFFICE_REPLENISHMENT_EXCEL_COLUMN } from "src/util/columns";
import Label from "../common/Label/Label";
import { DeleteOutline } from "@mui/icons-material";
import moment from "moment";
import dayjs, { Dayjs } from "dayjs";
import {
  fetchofficeReplenishmentPOHistory,
  officeReplenishmentVendorList,
  SubmitReplenishmentPO,
} from "src/components/officeReplenishmentPO/sagas";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  IconButton,
  Button as MuiButton,
  Tooltip,
} from "@mui/material";
import { ACTION } from "src/util/utils";
import { utils, writeFile } from "xlsx";
import { CloseIcon } from "../common/icons";
import { useMsal } from "@azure/msal-react";
import { DownloadOutlined } from "@ant-design/icons";
import { useFeaturePermission } from "src/context/FeaturePermissionContext";
import { FEATURE_NAMES } from "src/util/constants/feature.constants";
dayjs.extend(isSameOrAfter);

interface POItem {
  PONumber: string;
  vendorName: string;
  poFileName: string;
  isElectronic: boolean;
  data: any[];
  id: string;
  status: string;
}

const { Option } = Select;
function OfficeReplenishmentPO() {
  const userName = getUserName();
  const { accounts } = useMsal();
  const { isReadOnly } = useFeaturePermission(FEATURE_NAMES.OfficeReplenishmentPO);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const [vendorId, setVendorId] = useState<any>(undefined);
  const [vendors, setVendors] = useState<any>([]);
  const [collections, setCollections] = useState<any>([]);
  const [selectedCollections, setSelectedCollections] = useState([]);
  const [offices, setOffices] = useState<any>([]);
  const [selectedOffices, setSelectedOffices] = useState([]);
  const [PONumber, setPONumber] = useState("");
  const [VariancePercent, setVariancePercent] = useState(10);
  const [LastInventoryDate, setLastInventoryDate] = useState<Dayjs | null>();
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectedRow, setSelectedRow] = useState<any>([]);
  const [filteredData, setFilteredData] = useState<any>([]);
  const [updateData, setupdateData] = useState<any>([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [exportFile, setExportFile] = useState(false);
  const ExcelJS = require("exceljs");
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [visibleDelete, setVisibleDelete] = useState(false);
  const [deleteData, setDeleteData] = useState(false);
  const [bulkCancelModal, setBulkCancelModal] = useState(false);
  const [ShowOpenTransfers, setShowOpenTransfers] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [submitConfirmation, setSubmitConfirmation] = useState(false);
  const [showPreviewPopUp, setShowPreviewPopup] = useState(false);
  const [poSubmitResponse, setPoSubmitResponse] = useState<any>(null);  
  const [submittedVendors, setSubmittedVendors] = useState<string[]>([]);  
  const handleOpenPOSummaryPopup = () => setShowPreviewPopup(true);
  const handleClosePOSummaryPopup = () => {
    setShowPreviewPopup(false);
    setSubmitConfirmation(false);
    setConfirmLoading(false);
    setSelectedPOs([]);
    setPoSubmitResponse(null);
  };
  const [selectedPOs, setSelectedPOs] = useState<string[]>([]);
  const [vendorSFTPMap, setVendorSFTPMap] = useState<Record<string, boolean>>(
    {}
  );

  const getVendorReplenishmentList = () => {
    officeReplenishmentVendorList()
      .then((res: any) => {
        const sortedVendors = res?.sort((a: any, b: any) => {
          return a.VendorName.localeCompare(b.VendorName, "en", {
            numeric: true,
          });
        });

        const sftpMap: Record<string, boolean> = {};
        sortedVendors.forEach((vendor: any) => {
          sftpMap[vendor.VendorName] = vendor.IsSFTP ?? false;
        });

        setVendorSFTPMap(sftpMap);
      })
      .catch((error: any) => {
        showErrorNotification(error?.response?.data?.error?.messages[0]);
      });
  };

  const toggleAllPOSelection = (vendors: string[]) => {
    setSelectedPOs(vendors);
  };

  const togglePOSelection = (vendorName: string, isChecked: boolean) => {
    setSelectedPOs((prevSelected: string[]) => {
      if (isChecked) {
        return prevSelected.includes(vendorName)
          ? prevSelected
          : [...prevSelected, vendorName];
      } else {
        return prevSelected.filter((name) => name !== vendorName);
      }
    });
  };

  const handleExportAll = () => {
    if (!officeReplenishmentData || officeReplenishmentData.length === 0) {
      showErrorNotification("No data available to export.");
      return;
    }

    const dataToExport =
      selectedPOs.length === 0
        ? officeReplenishmentData
        : officeReplenishmentData.filter((item: any) =>
          selectedPOs.includes(item.Vendor)
        );

    const vendorGroups: Record<string, any[]> = {};

    dataToExport.forEach((item: any) => {
      const vendor = item.Vendor || "Unknown";
      if (!vendorGroups[vendor]) {
        vendorGroups[vendor] = [];
      }
      vendorGroups[vendor].push(item);
    });

    Object.entries(vendorGroups).forEach(([vendor, data]) => {
      const fileName = PONumber
        ? `REP_${vendor.replace(/\s+/g, "_")}_PO_${PONumber}.csv`
        : `${vendor.replace(/\s+/g, "_")}_PO.csv`;

      exportToExcel(data, fileName);
    });

    showSuccessNotification("PO files for all vendors exported successfully.");
  };

  const handleExport = (vendorName: string) => {
    if (!officeReplenishmentData || officeReplenishmentData.length === 0) {
      return;
    }

    const filteredData = officeReplenishmentData.filter(
      (item: any) => item.Vendor === vendorName
    );

    if (filteredData.length === 0) {
      showErrorNotification(`No data found for vendor: ${vendorName}`);
      return;
    }

    const fileName = PONumber
      ? `REP_${vendorName.replace(/\s+/g, "_")}_PO_${PONumber}.csv`
      : `REP_${vendorName.replace(/\s+/g, "_")}_PO.csv`;

    exportToCSV(filteredData, fileName);
    showSuccessNotification("PO file exported successfully.");
  };

  const generateCollectionQuantityMap = (data: any[]) => {
    const map: Record<string, number> = {};

    data.forEach((item) => {
      const collection = item.Collection;
      const quantity = parseFloat(item.FinalPOQuantity) || 0;

      if (collection) {
        map[collection] = (map[collection] || 0) + quantity;
      }
    });

    return map;
  };

  function exportToCSV(data: any[], filename: string) {
    const collectionQuantityMap = generateCollectionQuantityMap(data);
    const headers = [
      { header: "Office Name", key: "LocationName" },
      { header: "officenum", key: "OfficeNum" },
      { header: "P.O. #", key: "PONumber" },
      { header: "Model", key: "Model" },
      { header: "Color#", key: "ColorNumber" }, 
      { header: "Color Description", key: "ColorDescription" },
      { header: "Eye Size", key: "EyeSize" },
      { header: "Bridge", key: "Bridge" },
      { header: "Temple", key: "Temple" },
      { header: "Retail", key: "Retail" },
      { header: "UPC", key: "UPC" },
      { header: "SKU QTY", key: "SKUQty" },
      { header: "PRICE", key: "MEDCost" },
    ];

    const formattedData = data.map((item) => {
      const row: Record<string, any> = {};
      const collection = item.Collection;
      const finalCollectionQty = collectionQuantityMap[collection] ?? 0;

      const onHand =
        typeof item.CollectionTotalOnHand === "number"
          ? item.CollectionTotalOnHand
          : 0;

      const collectionOnHandAfterPO = onHand + finalCollectionQty;

      headers.forEach((col) => {
        let val;
        switch (col.key) {
          case "PONumber":
            val = item["PONumber"];
            if (typeof val === "string") {
              if (/^[=+\-@]/.test(val)) {
                val = `="${val}"`;
              }
            }
            row[col.header] = val;
            break;

          default:
            val = item[col.key];
        }
        row[col.header] = val;
      });

      return row;
    });

    const worksheet = utils.json_to_sheet(formattedData);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Office_Replenishment_PO");
    writeFile(workbook, filename);
  }

  function exportToExcel(data: any[], filename: string) {
    const collectionQuantityMap = generateCollectionQuantityMap(data);
    const headers = [
      { header: "Office Name", key: "LocationName" },
      { header: "officenum", key: "OfficeNum" },
      { header: "P.O. #", key: "PONumber" },
      { header: "Model", key: "Model" },
      { header: "Color#", key: "ColorNumber" },
      { header: "Color Description", key: "ColorDescription" },
      { header: "Eye Size", key: "EyeSize" },
      { header: "Bridge", key: "Bridge" },
      { header: "Temple", key: "Temple" },
      { header: "Retail", key: "Retail" },
      { header: "UPC", key: "UPC" },
      { header: "SKU QTY", key: "SKUQty" },
      { header: "PRICE", key: "MEDCost" },
    ];

    const formattedData = data.map((item) => {
      const row: Record<string, any> = {};
      const collection = item.Collection;
      const finalCollectionQty = collectionQuantityMap[collection] ?? 0;

      const onHand =
        typeof item.CollectionTotalOnHand === "number"
          ? item.CollectionTotalOnHand
          : 0;

      const collectionOnHandAfterPO = onHand + finalCollectionQty;

      headers.forEach((col) => {
        switch (col.key) {
          case "PONumber":
            let val = item["PONumber"];
            if (typeof val === "string") {
              if (/^[=+\-@]/.test(val)) {
                val = `="${val}"`;
              }
            }
            row[col.header] = val;
            break;
          default:
            row[col.header] = item[col.key];
        }
      });

      return row;
    });

    const worksheet = utils.json_to_sheet(formattedData);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Office_Replenishment_PO");
    writeFile(workbook, filename);
  }

  const deleteModal = (record: any) => {
    setVisibleDelete(true);
    setDeleteData(record);
  };

  const submitModal = (record: any) => {
    setSubmitConfirmation(true);
  };
  const [filterValueData, setFilterValueData] = useState([]);
  const [form] = Form.useForm();

  const queuedPOList: POItem[] = useMemo(() => {
    const vendorsMap: any = {};
    filterValueData.forEach((row: any, key: any) => {
      const vendor = row.Vendor;
      const vendorId = row.VendorID;
      const id = row.ID1;
      const isElectronic = vendorSFTPMap[vendor] ?? false;
      if (!vendorsMap[vendor]) {
        vendorsMap[vendor] = {
          id: id,
          vendorName: vendor,
          isElectronic,
          poFileName: `${vendor} PO ${PONumber}.csv`,
          data: [],
          status: null,
        };
      }

      vendorsMap[vendor].data.push(row);
    });
    return Object.values(vendorsMap);
  }, [filterValueData, vendorSFTPMap, PONumber]);

  function formatPODataForCSV(
    data: any[],
    collectionQuantityMap: Record<string, number>
  ) {
    const headers = [
      { header: "Office Name", key: "LocationName" },
      { header: "officenum", key: "OfficeNum" },
      { header: "P.O. #", key: "PONumber" },
      { header: "Model", key: "Model" },
      { header: "Color#", key: "ColorNumber" },
      { header: "Color Description", key: "ColorDescription" },
      { header: "Eye Size", key: "EyeSize" },
      { header: "Bridge", key: "Bridge" },
      { header: "Temple", key: "Temple" },
      { header: "Retail", key: "Retail" },
      { header: "UPC", key: "UPC" },
      { header: "SKU QTY", key: "SKUQty" },
      { header: "PRICE", key: "MEDCost" },
    ];

    const formattedData = data.map((item) => {
      const row: Record<string, any> = {};
      const collection = item.Collection;
      const finalCollectionQty = collectionQuantityMap[collection] ?? 0;

      const onHand =
        typeof item.CollectionTotalOnHand === "number"
          ? item.CollectionTotalOnHand
          : 0;

      const collectionOnHandAfterPO = onHand + finalCollectionQty;

      headers.forEach((col) => {
        switch (col.key) {
          case "PONumber":
            let val = item["PONumber"];
            if (typeof val === "string") {
              if (/^[=+\-@]/.test(val)) {
                // Wrap value in a formula string to force text rendering
                val = `="${val}"`;
              }
            }
            row[col.header] = val;
            break;

          default:
            row[col.header] = item[col.key];
        }
      });

      return row;
    });

    return { formattedData, headers };
  }

  const handleSubmitPOs = async () => {
    setConfirmLoading(true);
    setSubmitConfirmation(false);
    setLoader(true);
    const submittedBy = accounts?.length ? accounts[0].username : "";
    const details = [];
    const formData = new FormData();

    const poListToSubmit =
      selectedPOs.length === 0
        ? queuedPOList
        : queuedPOList.filter((item) => selectedPOs.includes(item.vendorName));

    for (const item of poListToSubmit) {
      const {
        PONumber = "",
        vendorName = "",
        poFileName = "",
        isElectronic = false,
        data = [],
      } = item;
      details.push({
        PONumber,
        VendorName: vendorName,
        FileName: poFileName,
        IsElectronic: isElectronic,
        Id: item.id,
      });

      const collectionQuantityMap = generateCollectionQuantityMap(data);
      const { formattedData, headers } = formatPODataForCSV(
        data,
        collectionQuantityMap
      );

      const escape = (val: any) => `"${String(val ?? "").replace(/"/g, '""')}"`;
      const csvContent = [
        headers.map((h) => h.header).join(","),
        ...formattedData.map((row: any) =>
          headers.map((h) => escape(row[h.header])).join(",")
        ),
      ].join("\n");

      const blob = new Blob(["\uFEFF" + csvContent], {
        type: "text/csv;charset=utf-8;",
      });

      const file = new File([blob], poFileName, { type: "text/csv" });
      formData.append(poFileName, file);
    }

    const records = {
      SubmittedBy: submittedBy,
      details,
    };
    formData.append("records", JSON.stringify(records));

    try {
      SubmitReplenishmentPO(formData)
        .then((res: any) => {
          setConfirmLoading(false);
          showSuccessNotification(res.Response);
          setPoSubmitResponse(res.POFileDetails);

          const submitted = poListToSubmit.map((item) => item.vendorName);
          setSubmittedVendors((prev) => [...prev, ...submitted]);
          setSelectedPOs([]); // Uncheck all
        })
        .catch((error: any) => {
          showErrorNotification(error?.response?.data?.error?.messages[0]);
        });
    } catch (error) {
      console.error("Error submitting POs:", error);
      showErrorNotification("Failed to submit POs");
    } finally {
      setLoader(false);
    }
  };

  let filterValues = filterColumns(
    updateData,
    setupdateData,
    filterValueData,
    setFilterValueData,
    deleteModal
  );
  const officeReplenishmentData = useSelector(
    (state: any) => state[`${MODULE_KEY}${ACTION.STATE_KEY}`].data
  );

  useEffect(() => {
    getVendorList();
    getVendorReplenishmentList();
    getOffices({})
      .then((res: any) => {
        const sortedOffice: any = res?.sort((a: any, b: any) => {
          return (
            a.LocationNumber !== null &&
            a.LocationNumber.localeCompare(b.LocationNumber, "en", {
              numeric: true,
            })
          );
        });
        setOffices(sortedOffice);
      })
      .catch((error: any) => {
        showErrorNotification(error?.response?.data?.error?.messages[0]);
      });
  }, []);

  const getVendorList = () => {
    fetchVendorList()
      .then((res: any) => {
        const sortedVendors = res?.sort((a: any, b: any) => {
          return a.VendorName.localeCompare(b.VendorName, "en", {
            numeric: true,
          });
        });
        setVendors(sortedVendors);
      })
      .catch((error: any) => {
        showErrorNotification(error?.response?.data?.error?.messages[0]);
      });
  };

  useEffect(() => {
    if (vendorId) {
      getCollectionByVendor(vendorId).then((res: any) => {
        const sortedCollections: any = res?.sort((a: any, b: any) => {
          return a.Description.localeCompare(b.Description, "sv");
        });
        setCollections(sortedCollections);
      });
    }
  }, [vendorId]);
  const changeVendor = (id: any) => {
    setVendorId(id);
  };

  useEffect(() => {
    if (filterValueData) {
      setTotalQuantity(handleTotalQuantity(filterValueData));
      setTotalCost(handleTotalCost(filterValueData));
    }
  }, [filterValueData]);

  useEffect(() => {
    if (filterValues?.data) {
      setupdateData([]);
      setFilterValueData(filterValues?.data);

      const quantity = handleTotalQuantity(filterValues?.data);
      const cost = handleTotalCost(filterValues?.data);
      setTotalQuantity(quantity);
      setTotalCost(cost);
    }
  }, [filterValues?.data]);

  useEffect(() => {
    const selectedIds = Object.keys(rowSelection).filter(
      (id) => rowSelection[id]
    );
    const selectedRows = selectedIds.map(
      (index) => filterValueData[parseInt(index)]
    );
    setSelectedRow(selectedRows);
  }, [rowSelection]);

  useEffect(() => {
    fetchofficeReplenishmentPOHistory({}).then((res: any) => {
      const parsed = res?.LastInventoryDate
        ? dayjs(res.LastInventoryDate, "YYYY-MM-DD")
        : null;
      setLastInventoryDate(parsed);
      // ensure Form UI updates when API returns
      form.setFieldsValue({ LastInventoryDate: parsed });
    });
  }, []);

  const closeModal = (e: React.MouseEvent<HTMLButtonElement>) => {
    setExportFile(true);
  };

  const bulkCancelModalOpen = () => {
    setBulkCancelModal(true);
  };

  const handleReject = () => {
    const updatedData = filterValueData.filter(
      (index: any) => !selectedRow.includes(index)
    );
    setFilterValueData(updatedData);
    setSelectedRow([]);
    setRowSelection({});
    setBulkCancelModal(false);
  };

  const handleDelete = () => {
    const updatedData = filterValueData.filter(
      (_: any, i: any) => i !== deleteData
    );
    setFilterValueData(updatedData);
    setVisibleDelete(false);
  };

  const handleGeneratePO = async (showTransfers = ShowOpenTransfers) => {
    const formattedDate = dayjs(LastInventoryDate);
    const payload = {
      OfficeList: selectedOffices.join(",").split(","),
      VendorID: vendorId ? vendorId : null,
      Collections: selectedCollections.join(","),
      UserName: userName,
      PONo: PONumber,
      VariancePercent: VariancePercent,
      LastInventoryDate: formattedDate.isValid()
        ? formattedDate.format("YYYY-MM-DD")
        : null,
      ShowOpenTransfers: showTransfers,
    };
    dispatch(
      fetchOfficeReplenishmentPOList(payload, () => {
        setShowPreview(true);
      })
    );
  };

  const handlePOPreview = async () => {
    handleOpenPOSummaryPopup();
  };

  const handleTotalQuantity = (dataSource: any[]) => {
    let total = 0;

    dataSource?.forEach((item: any) => {
      const quantity = parseFloat(item?.FinalPOQuantity ?? 0);
      if (!isNaN(quantity)) {
        total += quantity;
      }
    });

    return total;
  };

  const handleTotalCost = (dataSource: any[]) => {
    let total = 0;

    dataSource?.forEach((item: any) => {
      const quantity = parseFloat(item?.FinalPOQuantity ?? 0);
      const medCost = parseFloat(item?.MEDCost ?? 0);
      if (!isNaN(quantity) && !isNaN(medCost)) {
        total += quantity * medCost;
      }
    });

    return total;
  };

  const exportExcelFile = async () => {
    setConfirmLoading(true);
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("My Sheet");
    sheet.columns = OFFICE_REPLENISHMENT_EXCEL_COLUMN;
    const data =
      filteredData?.map((row: any) => row.original).length > 0
        ? filteredData?.map((row: any) => row.original)
        : filterValues.data;
    try {
      if (data?.length > 0) {
        setExportFile(false);
        let color;
        const promise = Promise.all(
          data?.map(async (item: any, index: number) => {
            const rowNumber = index + 2;
            sheet.addRow({
              ID1: item?.ID1,
              LocationName: item.LocationName,
              OfficeNum: item?.OfficeNum,
              Vendor: item?.Vendor,
              Collection: item?.Collection,
              Model: item?.Model,
              ColorNumber: item?.ColorNumber,
              ColorDescription: item?.ColorDescription,
              EyeSize: item?.EyeSize,
              UPC: item?.UPC,
              SKUQty: item?.SKUQty,
              FrameType: item?.FrameType,
              MEDCost: item?.MEDCost,
              EffectiveDate: item?.EffectiveDate?.substring(0, 10),
              ArrangerQty: item?.ArrangerQty,
              CollectionTotalOnHand: item?.CollectionTotalOnHand,
              PONumber: item?.PONumber,
              CollectionOnHand: item?.CollectionOnHand,
              SuggestedPOQuantity: item?.SuggestedPOQuantity,
              FinalPOQuantity: item?.FinalPOQuantity,
            });
          })
        );

        promise.then(() => {
          workbook.xlsx.writeBuffer().then(function (res: BlobPart) {
            const blob = new Blob([res], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = "Office-Replenishment-Report.csv";
            anchor.click();
            window.URL.revokeObjectURL(url);
          });
          showSuccessNotification("Excel downloaded successfully");
        });
      } else {
        setExportFile(false);
        setConfirmLoading(false);
        showErrorNotification("No data available to export");
      }
    } catch (error: any) {
      setExportFile(false);
      setConfirmLoading(false);
      showErrorNotification(error.response.data.error.messages[0]);
    }
  };

  return (
    <Spin spinning={loader}>
      <div>
        <Divider />
        <Breadcrumb>
          <span>Office Replenishment PO</span>
        </Breadcrumb>
        <TableFilter>
          <Form
            form={form}
            style={{ marginBottom: -20, borderRadius: 6 }}
            initialValues={{
              VariancePercent,
              LastInventoryDate: LastInventoryDate ? dayjs(LastInventoryDate, 'YYYY-MM-DD') : null,
            }}
          >
            <Row gutter={[16, 16]} justify="start" align="middle">
              {/* Vendor Select */}
              <Col flex="0 0 140px" xs={24} sm={12} md={3} lg={2}>
                <Form.Item>
                  <Select
                    className="d-flex align-items-center gap-2"
                    placeholder="Select Vendor"
                    disabled={loader}
                    showSearch
                    value={vendorId}
                    style={{ width: '100%' }}
                    optionFilterProp="children"
                    onChange={(value: string) => {
                      changeVendor(value);
                      setSelectedCollections([]);
                    }}
                    size="small"
                    allowClear
                  >
                    {vendors?.map(({ ID, VendorName }: any) => (
                      <Option key={ID} value={ID}>
                        {VendorName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              {/* Collection Select */}
              <Col flex="0 0 140px" xs={24} sm={12} md={3} lg={2}>
                <Form.Item>
                  <Select
                    mode="multiple"
                    allowClear
                    showSearch
                    value={selectedCollections}
                    style={{ width: '100%', marginLeft: '-8px' }}
                    placeholder="Select Collection(s)"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option!.children as unknown as string)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    onChange={(value) => setSelectedCollections(value)}
                    optionLabelProp="label"
                    maxTagCount="responsive"
                  >
                    {collections?.map((item: any, index: Key | null | undefined) => (
                      <Option key={index} value={item?.ID} label={item?.Description}>
                        {item?.Description}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              {/* Office Select */}
              <Col flex="0 0 140px" xs={24} sm={12} md={3} lg={2}>
                <Form.Item>
                  <Select
                    mode="multiple"
                    allowClear
                    showSearch
                    style={{ maxWidth: '90px', marginLeft: '-14px' }}
                    placeholder="Select Office(s)"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option!.children as unknown as string)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    onChange={(value) => setSelectedOffices(value)}
                    optionLabelProp="label"
                    maxTagCount="responsive"
                  >
                    {offices?.map((item: any, index: Key | null | undefined) => (
                      <Option key={index} value={item?.LocationNumber} label={item?.LocationNumber}>
                        {item?.LocationNumber}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              {/* PO Number Input */}
              <Col flex="0 0 140px" xs={24} sm={12} md={3} lg={2} style={{ maxWidth: 80 }}>
                <Form.Item
                  name="PONumber"
                  rules={[
                    {
                      required: true,
                      message: `Please enter PO number`,
                    },
                  ]}
                >
                  <Input
                    placeholder="PO Number"
                    style={{ maxWidth: '90px', marginLeft: '-19px' }}
                    onChange={(val: any) => {
                      setPONumber(val.target.value);
                    }}
                    maxLength={20}
                  />
                </Form.Item>
              </Col>

              {/* Variance Percentage Input */}
              <Col flex="0 0 140px" xs={24} sm={12} md={3} lg={2} style={{ maxWidth: 90 }}>
                <Form.Item
                  name="VariancePercent"
                  rules={[
                    {
                      required: false,
                      message: `Variance Percentage`,
                    },
                    {
                      pattern: /^(99|[1-9]?[0-9])$/,
                      message: 'Enter a number between 0 and 99',
                    },
                  ]}
                >
                  <Input
                    placeholder="Variance Percentage"
                    name="VariancePercent"
                    type="text"
                    value={VariancePercent}
                    min={0}
                    max={99}
                    maxLength={2}
                    style={{ width: '100%', marginLeft: '-20px' }}
                    onChange={(val: any) => {
                      setVariancePercent(val.target.value);
                    }}
                    suffix="%"
                  />
                </Form.Item>
              </Col>

              {/* Last Inventory Date Picker */}
              <Col flex="0 0 140px" xs={24} sm={12} md={3} lg={2}>
                <Form.Item
                  name="LastInventoryDate"
                  rules={[
                    {
                      required: true,
                      message: 'Please select the Last Inventory Date',
                    },
                    {
                      validator: (_, value) => {
                        if (value && value.isAfter(moment())) {
                          return Promise.reject('Future dates are not allowed');
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <DatePicker
                    placeholder="Last Inventory Date"
                    value={LastInventoryDate ? dayjs(LastInventoryDate, 'YYYY-MM-DD') : null}
                    onChange={(date) => {
                      setLastInventoryDate(date ? dayjs(date, 'YYYY-MM-DD') : null);
                     // keep form and local state in sync
                     form.setFieldsValue({ LastInventoryDate: date ? dayjs(date, 'YYYY-MM-DD') : null });
                    }}
                    format="YYYY-MM-DD"
                    disabledDate={(current) =>
                      current && current.isSameOrAfter(dayjs().subtract(0, 'day'), 'day')
                    }
                    style={{ width: '100%', marginLeft: '-20px' }}
                  />
                </Form.Item>
              </Col>

              {/* Show Open Transfers Switch */}
              <Col flex="0 0 140px" xs={24} sm={12} md={3} lg={2} style={{ maxWidth: 100, marginLeft: '-20px' }}>
                <Form.Item>
                  <Label
                    label="Show Open Transfers"
                    className="flex-row align-items-center fs-6 gap-2"
                  >
                    <Switch
                      size="small"
                      style={{ marginLeft: -11 }}
                      checked={ShowOpenTransfers}
                      onChange={(checked) => {
                        setShowOpenTransfers(checked);
                        if (filterValueData.length > 0) {
                          handleGeneratePO(checked);
                        }
                      }}
                    />
                  </Label>
                </Form.Item>
              </Col>

              {/* Generate PO Button */}
              {/* Buttons: Fixed width to prevent shrink */}
              <Col flex="0 0 140px" xs={24} sm={12} md={3} lg={2} style={{ maxWidth: 100, marginBottom: 20, marginRight: 4, marginLeft: 2 }}>
                <Button
                  onClick={() => handleGeneratePO(ShowOpenTransfers)}
                  size="middle"
                  style={{ padding: '2px 6px', height: '30px' }}
                  disabled={
                    !(selectedOffices.length || selectedCollections.length) ||
                    (VariancePercent?.toString() !== '' &&
                      !/^(99|[1-9]?[0-9])$/.test(VariancePercent?.toString())) ||
                    !dayjs(LastInventoryDate).isValid() ||
                    dayjs(LastInventoryDate).isAfter(dayjs(), 'day')
                  }
                >
                  Generate PO
                </Button>
              </Col>

              {/* Preview PO(s) Button */}
              <Col flex="0 0 140px" xs={24} sm={12} md={3} lg={2} style={{ maxWidth: 100, marginBottom: 20, marginRight: 12, marginLeft: 2 }}>
                <Button
                  style={{ padding: '2px 8px', height: '30px' }}
                  onClick={handlePOPreview}
                  size="middle"
                  disabled={!showPreview}
                >
                  Preview PO(s)
                </Button>
              </Col>
              <Dialog
                open={showPreviewPopUp}
                onClose={handleClosePOSummaryPopup}
                maxWidth="md"
                fullWidth
              >
                <Spin spinning={confirmLoading}>
                  <DialogTitle
                    sx={{
                      m: 0,
                      p: 2,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <strong style={{ fontSize: "1rem" }}>PO Summary</strong>
                    <IconButton
                      aria-label="close"
                      onClick={handleClosePOSummaryPopup}
                      sx={{
                        color: (theme) => theme.palette.grey[500],
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell style={{ paddingLeft: "15px" }}>
                            <Checkbox
                              checked={
                                selectedPOs.length === queuedPOList.length &&
                                queuedPOList.length > 0
                              }
                              indeterminate={
                                selectedPOs.length > 0 &&
                                selectedPOs.length < queuedPOList.length
                              }
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                const allVendors = queuedPOList
                                  .filter((item) => !submittedVendors.includes(item.vendorName))
                                  .map((item) => item.vendorName);
                                toggleAllPOSelection(isChecked ? allVendors : []);
                              }}
                              disabled={queuedPOList.every((item) =>
                                submittedVendors.includes(item.vendorName)
                              )}
                            />
                          </TableCell>
                          <TableCell>
                            <strong>Electronic</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Vendor</strong>
                          </TableCell>
                          <TableCell>
                            <strong>File Name</strong>
                          </TableCell>
                          <TableCell>
                            <strong> </strong>
                          </TableCell>
                          <TableCell>
                            <strong>Status</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {queuedPOList.map((item: any) => (
                          <TableRow key={item.Id}>
                            <TableCell>
                              <Checkbox
                                checked={selectedPOs.includes(item.vendorName)}
                                onChange={(e) =>
                                  togglePOSelection(item.vendorName, e.target.checked)
                                }
                                disabled={submittedVendors.includes(item.vendorName)}
                              />
                            </TableCell>
                            <TableCell>
                              {item.isElectronic ? "Yes" : "No"}
                            </TableCell>
                            <TableCell>{item.vendorName}</TableCell>
                            <TableCell>{item.poFileName}</TableCell>
                            <TableCell>
                              <Button
                                size="small"
                                onClick={() => handleExport(item.vendorName)}
                              >
                                Export
                              </Button>
                            </TableCell>
                            <TableCell>
                              {poSubmitResponse !== null &&
                                poSubmitResponse?.filter(
                                  (e: any) => e.VendorName === item.vendorName
                                )[0]?.Message}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </DialogContent>
                  <DialogActions>
                    <Button size="small" onClick={handleExportAll}>
                      Export All
                    </Button>
                    <Tooltip
                      title="Please select at least one record"
                      disableHoverListener={selectedPOs.length > 0}
                    >
                      <span>
                        <Button
                          size="small"
                          onClick={submitModal}
                          hidden={isReadOnly}
                          disabled={selectedPOs.length === 0}
                        >
                          Submit
                        </Button>
                      </span>
                    </Tooltip>
                  </DialogActions>
                </Spin>
              </Dialog>
              <Modal
                title="Submit PO Confirmation"
                okText="Ok"
                centered
                confirmLoading={confirmLoading}
                style={{ top: 10 }}
                open={submitConfirmation}
                onCancel={() => setSubmitConfirmation(false)}
                zIndex={2000}
                footer={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "12px",
                      marginBottom: "15px",
                    }}
                  >
                    <Button
                      danger
                      size="middle"
                      onClick={() => setSubmitConfirmation(false)}
                      style={{ padding: "8px 20px", fontSize: "12px" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      size="middle"
                      onClick={handleSubmitPOs}
                      style={{ padding: "8px 24px", fontSize: "12px" }}
                    >
                      Ok
                    </Button>
                  </div>
                }
              >
                <div style={{ marginBottom: "-10px" }}>
                  <span>
                    Are you sure you wish to finalize and submit this PO?
                  </span>
                </div>
              </Modal>

              {/* Reject Button */}
              <Col flex="0 0 140px" xs={24} sm={12} md={3} lg={2} style={{ maxWidth: 100, marginBottom: 20, marginLeft: 2 }}>
                <Button
                  danger
                  size="middle"
                  style={{ padding: '2px 16px', height: '30px' }}
                  icon={
                    <DeleteOutline
                      style={{ marginLeft: -8, marginRight: -5, borderRadius: 6, fontSize: 20 }}
                    />
                  }
                  disabled={!selectedRow || selectedRow.length < 1}
                  onClick={bulkCancelModalOpen}
                >
                  Reject
                </Button>
              </Col>
              <Col flex="0 0 140px" xs={24} sm={12} md={3} lg={2} style={{ maxWidth: 100, marginBottom: 20, marginRight: 12 }}>
               <Button
                  size="middle"
                  icon={<DownloadOutlined />}
                  ant-click-animating-without-extra-node="true"
                  onClick={closeModal}
                  disabled={filteredData.length === 0}
                >
              {" "}
              Export
            </Button>
              </Col>
              {/* Final PO Quantity */}
              <Col flex="0 0 140px" xs={24} sm={12} md={3} lg={2} style={
                { maxWidth: 120 }
              }>
                <Form.Item name="Final PO Quantity">
                  <Label
                    label={'Total PO Quantity: ' + totalQuantity.toLocaleString('en-US')}
                    className="flex-row align-items-center fs-6 gap-3"
                  >
                    <></>
                  </Label>
                </Form.Item>
              </Col>

              {/* Final PO Cost */}
              <Col flex="0 0 140px" xs={24} sm={12} md={3} lg={2} style={
                { marginLeft: -20, maxWidth: 120 }}>
                <Form.Item name="Final PO Cost">
                  <Label
                    label={
                      'Total PO Cost: ' + totalCost.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                    }
                    className="flex-row align-items-center fs-6 gap-3"
                  >
                    <></>
                  </Label>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </TableFilter>

        <GenericGrid
          columns={filterValues.columns}
          data={filterValueData}
          enableRowSelection={true}
          onRowSelectionChange={setRowSelection}
          rowSelection={rowSelection}
          setRowSelection={setRowSelection}
          filterDisplayMode="popover"
          highlightFilterMatch={true}
          paginationDisplayMode="pages"
          paginationProps={{
            color: "primary",
            shape: "rounded",
            showRowsPerPage: true,
            variant: "outlined",
            rowsPerPageOptions: [10, 50, 100, 500, 1000],
          }}
          enableStickyHeader={true}
          enableStickyFooter={true}
          enableColumnPinning={true}
          enableEditing={true}
          columnPinning={{}}
          isLoading={filterValues.loading}
          muiTableBodyCellProps={{
            sx: {
              fontSize: "10px",
              textAlign: "left",
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              fontSize: "10px",
              fontWeight: "800",
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
              textAlign: "left",
              padding: "5px 10px",
            },
          }}
          muiTableBodyRowProps={{
            sx: {
              "& td": {
                padding: "5px 10px",
              },
            },
          }}
          filteredData={filteredData}
          setFilteredData={setFilteredData}
        ></GenericGrid>
        <Modal
          title="Excel export Confirmation"
          okText="Ok"
          open={exportFile}
          centered
          confirmLoading={loader}
          style={{ top: 20 }}
          onOk={exportExcelFile}
          onCancel={() => setExportFile(false)}
        >
          <span>Are you sure you want to export this data?</span>
        </Modal>
        <Modal
          title="Delete Confirmation"
          okText="Ok"
          centered
          confirmLoading={confirmLoading}
          style={{ top: 10 }}
          open={visibleDelete}
          onOk={handleDelete}
          onCancel={() => setVisibleDelete(false)}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
                marginBottom: "15px",
              }}
            >
              <Button
                danger
                size="middle"
                onClick={() => setVisibleDelete(false)}
                style={{ padding: "8px 20px", fontSize: "12px" }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                size="middle"
                onClick={handleDelete}
                style={{ padding: "8px 24px", fontSize: "12px" }}
              >
                Ok
              </Button>
            </div>
          }
        >
          <div style={{ marginBottom: "-10px" }}>
            <span>
              Are you sure you want to remove this SKU from the current PO?
            </span>
          </div>
        </Modal>
        <Modal
          title="Reject Confirmation"
          okText="Ok"
          centered
          confirmLoading={confirmLoading}
          style={{ top: 5, bottom: 10, marginBottom: 30 }}
          open={bulkCancelModal}
          onOk={handleReject}
          onCancel={(e) => setBulkCancelModal(false)}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
                marginBottom: "15px",
              }}
            >
              <Button
                danger
                size="middle"
                onClick={() => setBulkCancelModal(false)}
                style={{ padding: "8px 20px", fontSize: "12px" }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                size="middle"
                onClick={handleReject}
                style={{ padding: "8px 24px", fontSize: "12px" }}
              >
                Ok
              </Button>
            </div>
          }
        >
          <div style={{ marginBottom: "-10px" }}>
            <span>
              Are you sure you want to remove this SKU from the current PO?
            </span>
          </div>
        </Modal>
      </div>
    </Spin>
  );
}
const StyledDiv = styled.div`
  color: #fff;
  position: absolute;
  left: 24%;
  font-size: 16px;
`;
export default OfficeReplenishmentPO;
